import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };


  #checkCartForSize() {
    fetch('/cart.js')  // Fetch the current cart in JSON format
      .then(response => response.json())
      .then(cart => {
        let sizeCount = 0;
        const minQuantity = 10;  // Minimum quantity required for size "6x6"

        // Loop through cart items and check for size "6x6"
        cart.items.forEach(item => {
          if (item.properties._Size === "6x6") {
            sizeCount += item.quantity;
          }
        });

        // If there are fewer than 10 items of size "6x6", show an alert and disable checkout
        if (sizeCount < minQuantity) {
          alert('You need at least 10 items of size 6x6 in your cart before proceeding to checkout.');
          document.querySelector('.checkout-button').disabled = true;  // Disable checkout button
        } else {
          document.querySelector('.checkout-button').disabled = false;  // Enable checkout button
        }
      })
      .catch(error => console.error('Error fetching cart:', error));
  }

      
  open() {
    this.showDialog();
    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
